module.exports = __webpack_public_path__ + "static/media/InverterPlusTop.379245fb.pdf";